// Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export const COIN_GECKO_IOTA_URL = 'https://www.coingecko.com/en/coins/iota';
